import './SearchResult.scss';
import Result from './Result.jsx';

const platforms = [
  'Hyread',
  'UDN',
  '國立公共資訊圖書館',
  '台灣雲端書庫',
  '華藝電子書',
];

const SearchResult = () => {
  return (
    <div className="result-container">
      <h3 className="result-header">搜尋結果</h3>
      <div className="result-content">
        {platforms.map((platform) => (
          <Result platform={platform} />
        ))}
      </div>
    </div>
  );
};

export default SearchResult;
